import React, { useEffect, useState } from "react";
import UserModal from "./UserModal";
import { deleteDoc } from "firebase/firestore";
import { send } from "@emailjs/browser";
import { sendOtp, getUser } from "../services/authservice";
import { doc, getDoc, getDocs} from "firebase/firestore";
import { db } from "../firebase";
const Login = ({ onLogin }) => {
  // const [username, setUsername] = useState("");
  // const [password, setPassword] = useState("");
  const [email,setEmail] = useState("");
  const [otp,setOtp] = useState("");
  const [showOtp, setShpwOtp] = useState(false);
  const [error, setError] = useState(null);
//  const [appMode, setAppMode] = useState("production");
  const [showDemoModal, setShowDemoModal] = useState(false);
  const LOGIN_URL = window.API_BASE_URL + "login";

//  useEffect(() => {
//    fetch(window.API_BASE_URL + "app-mode")
//      .then((res) => res.json())
//      .then((data) => setAppMode(data.mode || "production"))
//      .catch(() => setAppMode("production")); // fallback
//  }, []);
  const handleVerify = async (e) =>{
    e.preventDefault();
    if(!otp.trim()){
      setError("Enter OTP");
      return;
    }
try{
  const otpRef = doc(db,"otp",email);
  const snapShot = await getDoc(otpRef);

  if(!snapShot.exists())
  {
    setError("Enter Valid OTP");
    return;
  }

  const data = snapShot.data();

  if(Date.now() > data.expiresAt)
  {
    setError("OTP Expires");
    return;
  }

  if(otp === data.otp)
  {
  await deleteDoc(otpRef);
   const user = await getUser(email);
   onLogin(user);
  }
  else
  {
    setError("Enter Valid OTP");
  }
}
catch(error){
  setError("Error on Verify OTP");
  return;
}
  }
  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    if(!email.trim()){
      setError("Enter your mail");
      return;
    }

    try {
      await sendOtp(email);
      setShpwOtp(true);
      // const res = await fetch(LOGIN_URL, {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({ username, password }),
      // });
      // const data = await res.json();
      // if (res.ok) onLogin(data);
      // else setError(data.error || "Incorrect username or password");
    } catch (err) {
      setError(err.message);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") showOtp ?handleVerify(e) : handleLogin(e);
  };
  const emailChange = (e) =>{
    const value = e.target.value.replace(/[^a-zA-Z0-9@._%+-]/g,"");
    setEmail(value);
  }
  const otpChange = (e) =>{
    const value = e.target.value.replace(/\D/g,"").slice(0, 6);
    setOtp(value);
  }
  // ➕ Save new demo user and prefill login form
  const handleDemoSave = async (formData) => {
//    try {
      // const res = await fetch(window.API_BASE_URL + "users", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify(formData),
      // });
      
      // if (!res.ok) {
      //   const errData = await res.json();
      //   throw new Error(errData.detail || "Registration failed");
      // }

      // // ✅ success: prefill login form
      // setUsername(formData.username);
      // setPassword(formData.password);
      // setShowDemoModal(false);

//    } catch (err) {
//      console.error("Demo sign-up failed", err);
//      setError(err.message);
//    }
  };  


  

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cyan-900 via-cyan-800 to-cyan-700 px-4">
      {/* Card */}
      <div className="bg-white w-full max-w-sm rounded-2xl shadow-xl p-6 sm:p-10">
        {/* Header with adjusted gap */}
        <div className="flex justify-center items-center gap-4 mb-10">
          {/* Logo */}
          <svg
            className="w-10 h-10 text-gray-400"
            viewBox="0 0 1244 1244"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path fill="#ffffff" d="M1244 622c0 343.521-278.479 622-622 622S0 965.521 0 622 278.479 0 622 0s622 278.479 622 622z"/>
              <path fill="#2DAAE2" d="M964.76 629.496v307.722c0 11.921-9.628 21.782-21.778 21.782H916.16c-67.629 0-122.646-54.802-122.646-122.676V626.286c0-94.471-76.572-171.287-171.249-171.287-94.678 0-171.247 76.586-171.247 171.287v210.038c0 67.645-54.79 122.676-122.647 122.676h-26.593c-11.92 0-21.778-9.632-21.778-21.782V629.496c.229-189.172 153.366-342.344 342.494-342.344 189.131 0 342.266 153.172 342.266 342.344Z"/>
              <path fill="#F19300" d="M426.244 296.696c-56.54 30.27-103.695 76.135-135.514 131.861-2.746 4.816-10.3 2.981-10.3-2.523V295.09c0-5.504 4.349-10.09 10.072-10.09h130.477c2.976 0 5.265 1.147 7.096 2.981 2.289 2.752 1.374 7.109-1.831 8.715Z"/>
            </g>
          </svg>
  
          {/* Title */}
          <h2 className="text-2xl font-bold text-cyan-900">
            UTwin Dashboard
          </h2>
        </div>

        {/* Form with controlled spacing via space-y */}
        <form onSubmit={showOtp ? handleVerify : handleLogin} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
            type="email"
              className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:border-cyan-600"
              placeholder="Enter your email"
              value={email}
              onChange={emailChange}
            />
          </div>

          {showOtp && <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              OTP
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:border-cyan-600"
              placeholder="Enter OTP"
              value={otp}
              onChange={otpChange}
              onKeyDown={handleKeyDown}
            />
          </div>}

          {error && (
            <p className="text-red-600 text-sm text-center">{error}</p>
          )}

          <button
            type="submit"
            className="w-full bg-cyan-900 text-white py-2 rounded-md font-medium hover:bg-cyan-800 transition-colors"
          >
            { showOtp ? "Verify OTP" : "Login"}
          </button>
        </form>

        {/* 👇 Show Create-Demo button instead of a new page 
        {appMode === "demo" && (
          <div className="mt-4 text-center">
            <button
              type="button"
              onClick={() => setShowDemoModal(true)}
              className="text-cyan-700 text-sm font-medium hover:underline"
            >
              New user? Sign up for demo
            </button>
          </div>
        )}*/}

        {/* Footer moved inside the card and adjusted spacing */}
        <div className="mt-4 flex justify-between items-center">
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} Nesa Medtech
          </p>
          <p className="text-xs text-gray-400">
            Ver: 0.1 - 20251125
          </p>          
        </div>
      </div>

      {/* ➕ Reusable modal to register demo users */}
      <UserModal
        isOpen={showDemoModal}
        onClose={() => setShowDemoModal(false)}
        onSave={handleDemoSave}
        mode="add"
        isDemoRegistration={true}
        initialData={{ role: "demo" }}
        hospitals={[]}
        showHospitalSelect={false}
        error={error}   // ✅ pass error down
      />


    </div>
  );
};

export default Login;